var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVoiceMicOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3.25 10.25)",
    d: "M0.75 0.75C0.75 5.1683 4.33172 8.75 8.75 8.75M8.75 8.75C10.7045 8.75 12.4954 8.0491 13.8848 6.8848M8.75 8.75V11.75M8.75 11.75H11.75M8.75 11.75H5.75M16.75 0.75C16.75 2.4014 16.2496 3.9359 15.3922 5.2103",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6.25 1.25)",
    d: "M0.75 5.73V9.75C0.75 12.5114 2.98858 14.75 5.75 14.75C6.88534 14.75 7.91466 14.3596 8.754 13.722M10.1887 11.994C10.5473 11.3045 10.75 10.5809 10.75 9.75V9.738V5.73C10.75 2.96858 8.5114 0.75 5.75 0.75C3.88119 0.75 2.28009 1.71527 1.422 3.234",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1.25 1.25)",
    d: "M0.75 0.75L20.75 20.75",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoiceMicOff);
export default __webpack_public_path__ + "static/media/icon-voice-mic-off.163360abf15b85eda42348a602776075.svg";
export { ForwardRef as ReactComponent };